import React, { Component } from "react";
import { connect } from "react-redux";
import CaseSearchResults from "../components/caseSearchResults/caseSearchResults";
import Loading from "../components/loading/loading";
import * as caseSearchActions from "./caseSearchActions";
import * as matterActions from "../components/matter/matterActions";
import * as routes from "../shared/routes";
import Error from "../components/error/error"
import analytics from "../shared/analytics"

class CaseSearch extends Component {
  constructor(props) {
    super(props)
    analytics.pageView()
    this.componentRef = React.createRef()
  }

  componentDidMount() {
    this.props.onSetMatter("", "", null, null, null, null, null, null, null, null, null, null)
    this.props.onGetMatters(this.props.showClosedMatters, this.props.token)
    this.componentRef.current.addEventListener('change', this)
  }

  componentWillUnmount() {
    if (this.componentRef.current)
      this.componentRef.current.removeEventListener('change', this);
  }

  componentDidUpdate() {
    if (!this.props.showClosedMatters && !this.props.isSearched) {
      if (this.props.results !== null) {
        this.props.onSearch(true)
        if (this.props.results.length === 1) {
          let row = (this.props.results[0]);
          this.props.onSetMatter(
            row.reference,
            row.description,
            row.isUdModule,
            row.udModuleUid,
            row.udModuleName,
            row.masterProcessName,
            row.masterProcessId,
            row.id
          )
          this.props.history.push(routes.caseSummary);
        }
      }
    }
  }

  handleEvent(e) {
    if (e.detail && e.type === 'change' && e.target.id === "closed_matters_toggle") {
      if (e.detail.checked) {
        analytics.trackEvent(
          {
            "key": "Get.ClosedMatters"
          }
        );
      }

      this.props.onValueChanged(e.detail.checked)
      if (this.props.loading) return;
      this.props.onGetMatters(this.props.showClosedMatters, this.props.token)
    }
  }

  render() {
    if (this.props.error)
      return Error(this.props.error);

    let formContent = null

    if (!this.props.isSearched) {
      formContent =
        <mosaic-container>
          <mosaic-card>
            <mosaic-card-body>
              <div className='text-centre'>
                {Loading()}
              </div>
            </mosaic-card-body>
          </mosaic-card>
        </mosaic-container>
    }
    else {
      let resultContent =
        <div className='text-centre'>
          {Loading()}
        </div>

      if (!this.props.loading) {
        if (this.props.results !== null && this.props.results.length === 0) {
          resultContent =
            <mosaic-card>
              <mosaic-card-body>
                <div>There are no {this.props.showClosedMatters ? "closed" : "live"} matters to display </div>
              </mosaic-card-body>
            </mosaic-card>
        }
        else {
          resultContent =
            <div id="matterSearchHeader">
              <div>
                <CaseSearchResults
                  loading={this.props.loading}
                  error={this.props.error}
                  results={this.props.results}
                  showClosedMatters={this.props.showClosedMatters}
                />
              </div>
            </div>
        }
      }

      formContent =
        <mosaic-main-container fluid>
          <mosaic-page-header fixed title="Case Search" >
            <mosaic-toggle
              id="closed_matters_toggle"
              label=" Show Closed Matters"
              icon="checked_2"
              color="success"
              checked={this.props.showClosedMatters ? "checked" : null}
            />
          </mosaic-page-header>
          <div> {resultContent} </div>
        </mosaic-main-container>
    }

    return (
      <mosaic-content-container ref={this.componentRef}>
        {formContent}
      </mosaic-content-container>
    );
  }
}

const mapStateToProps = state => ({
  token: state.login.token,
  isClient: state.login.userType === 2,
  loading: state.matterSearch.loading,
  error: state.matterSearch.error,
  results: state.matterSearch.results,
  showClosedMatters: state.caseSearch.showClosedMatters,
  isSearched: state.caseSearch.isSearched
});

const mapDispatchToProps = dispatch => {
  return {
    onSetMatter: (reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone) =>
      dispatch(matterActions.setMatter(reference, description, isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone)),
    onGetMatters: (showClosedMatters, token) =>
      dispatch(caseSearchActions.getMatters(showClosedMatters, token)),
    onValueChanged: (showClosedMatters) =>
      dispatch(caseSearchActions.setShowClosedMatterFlag(showClosedMatters)),
    onSearch: (isSearched) =>
      dispatch(caseSearchActions.onSearch(isSearched))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseSearch);
